// 共享常量与工具：从 src/views/smart-workbench/index.vue 的模块级常量区拆出。
// index.vue 与各 mixin 从这里引用，避免重复定义。
import CeoWorkbench from '@/views/workbench/ceo/index.vue'
import CfoWorkbench from '@/views/workbench/cfo/index.vue'
import CsoWorkbench from '@/views/workbench/cso/index.vue'
import DirectorWorkbench from '@/views/workbench/director/index.vue'
import WorkbenchRender from '@/views/workbench/workbench/render/index.vue'
import { getWorkspaceId } from '@/api/agentAuth'
import Cookies from 'js-cookie'

export const WORKBENCH_COMPONENTS = {
  ceo: CeoWorkbench,
  cfo: CfoWorkbench,
  cso: CsoWorkbench,
  director: DirectorWorkbench,
  default: WorkbenchRender
}
export const WS_BASE_PATH = '/agent-api/intelligent-agent/api/v1/claw/ws'
export const WS_CLAW_ID = process.env.VUE_APP_WS_CLAW_ID || '2069625662527311874'
export const WS_TOKEN_KEY = process.env.VUE_APP_WS_TOKEN_KEY || 'tianzhi_test_agent_token'
export function getSharedWsUrl(workspaceId) {
  // tianzhi agent token 由 fetchAgentToken() 在登录后自动获取并存入 storage
  const token = Cookies.get(WS_TOKEN_KEY) || ''
  if (!token) return ''
  // 动态 workspace ID：优先使用传入的真实 workspaceId，其次用环境变量兜底
  let wsId = workspaceId
  if (!wsId) {
    try {
      wsId = getWorkspaceId()
    } catch (e) {
      console.log(e)
    }
  }
  if (!wsId) return ''
  return `${WS_BASE_PATH}?claw_id=${WS_CLAW_ID}&workspace_id=${wsId}&t=${encodeURIComponent(
    token
  )}`
}
